module.exports = "/_next/static/media/918e55dc992c0e84d99a2dbd865f5ddd.svg";